var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "prizeClaw",
      style: {
        backgroundImage:
          "url(" +
          JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
            .prizeClaw.background.pictureUrl +
          ")"
      }
    },
    [
      _c("div", { staticStyle: { height: "420px" } }),
      _c("div", {
        staticClass: "title",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .prizeClaw.title.pictureUrl +
            ")"
        }
      }),
      _c("div", {
        staticClass: "btn rulesBtn",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .prizeClaw.rulesBtn.pictureUrl +
            ")"
        }
      }),
      _c("div", {
        staticClass: "btn myPrize",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .prizeClaw.myPrize.pictureUrl +
            ")"
        }
      }),
      _c("div", {
        staticClass: "start",
        style: {
          backgroundImage:
            "url(" +
            JSON.parse(_vm.marketingActivityData.activity.templePage).drawPage
              .prizeClaw.start.pictureUrl +
            ")"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }